import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import LegacySelect from 'react-select-legacy';
import { useTranslation } from 'react-i18next';
import EditButtonSearch from './EditButtonSearch';
import FilterCheckbox from './FilterCheckbox';
import { isAdminDashboard } from 'utils/authScopes';
import { groupByDisabled } from 'utils/select';

const AccountsFilter = ({
  auth, meta, onSearch, onArchivedChange,
  cohorts, onCohortChange, groups, onGroupChange, partners,
  subgroups, onSubgroupChange,
  onPartnerChange, isLoading }) => {
  const { t } = useTranslation();
  return (
    <div className='row u-margin-top--base u-margin-bottom--large'>
      { isAdminDashboard(auth) &&
        <div className='column small-12 medium-4 large-3 u-margin-top--base'>
          <LegacySelect
            name='sp-partner-select'
            className={'o-select o-select--optgroup'}
            multi={true}
            value={meta.partners || ''}
            onChange={onPartnerChange}
            options={partners}
            placeholder={t('filters.allPartners')}
            simpleValue={true}
            disabled={isLoading}
          />
        </div> }
      { groups.length > 1 &&
        <div className='column small-12 medium-4 large-3 u-margin-top--base'>
          <Select
            name='sp-group-select'
            className={'o-select o-select--optgroup'}
            isMulti
            value={groups.filter(v => (meta.groups || '').split(',').map(i => parseInt(i)).includes(v.value))}
            onChange={(v) => onGroupChange(v.map(i => i.value).join(','))}
            options={groups}
            placeholder={t('filters.allGroups')}
            isDisabled={isLoading}
          />
        </div>
      }
      { subgroups.length > 1 &&
        <div className='column small-12 medium-4 large-3 u-margin-top--base'>
          <Select
            name='sp-cohort-select'
            className={'o-select o-select--optgroup'}
            isMulti
            value={subgroups.filter(v => (meta.subgroups || '').split(',').map(i => parseInt(i)).includes(v.value))}
            onChange={(v) => onSubgroupChange(v.map(i => i.value).join(','))}
            options={groupByDisabled(subgroups)}
            placeholder={t('filters.allSubgroups')}
            isDisabled={isLoading}
          />
        </div>
      }
      { cohorts.length > 1 &&
        <div className='column small-12 medium-4 large-3 u-margin-top--base'>
          <Select
            name='sp-cohort-select'
            className={'o-select o-select--optgroup'}
            isMulti
            value={cohorts.filter(v => (meta.cohorts || '').split(',').map(i => parseInt(i)).includes(v.value))}
            onChange={(v) => onCohortChange(v.map(i => i.value).join(','))}
            options={groupByDisabled(cohorts)}
            placeholder={t('filters.allCohorts')}
            isDisabled={isLoading}
          />
        </div>
      }
      <div className='column shrink align-self-middle u-margin-top--base'>
        <FilterCheckbox
          label={t('accountPlayers.filters.showArchived')}
          value={meta.archived || false} onChange={onArchivedChange}
          disabled={isLoading}
        />
      </div>
      <div className='column small-12 medium-4 large-3 o-filter--last u-margin-top--base'>
        <EditButtonSearch
          placeholder={t('accountPlayers.filters.searchByNameEmail')}
          value={meta.q} onChange={onSearch}
          disabled={isLoading}
        />
      </div>
    </div>
  );
}

AccountsFilter.propTypes = {
  auth: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  cohorts: PropTypes.arrayOf(PropTypes.object).isRequired,
  subgroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  partners: PropTypes.arrayOf(PropTypes.object).isRequired,
  withScope: PropTypes.object.isRequired,
  onArchivedChange: PropTypes.func.isRequired,
  onCohortChange: PropTypes.func.isRequired,
  onSubgroupChange: PropTypes.func.isRequired,
  onGroupChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onPartnerChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default AccountsFilter;
